import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ItemSearchResult from '../../../models/ItemSearchResult';
import DataService from "../../../services/data.service";
import { DataResult } from "../../../types/Result";

interface PopupProps {
    show: boolean
    onHide: (projectId?: number) => void
    selectedItems: ItemSearchResult[]
}

interface AddToProjectModel {
    projectId: number
    itemRevisionIds: number[] 
}

const AddToProjectPopup: React.FC<PopupProps> = ({ show, onHide, selectedItems }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<AddToProjectModel>>({ isSuccesful: true, messages: [], data: undefined });
    const projects = useSelectListOptions('api/v1/selectlist/Projects?activeOnly=true', '-- Select project');
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<AddToProjectModel>({
        projectId: 0,
        itemRevisionIds: selectedItems.map(item => item.itemRevisionId)
    });

    useEffect(() => {
        formData.itemRevisionIds = selectedItems.map(item => item.itemRevisionId)
        setFormData(formData)
    }, [selectedItems])

    function submit() {
        if (formData) {
            DataService
                .create<AddToProjectModel>(`api/v1/Projects/AddItems`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide(formData.projectId);
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string): void {
        formData[name] = value;
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'projectId', label: 'Project', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'xl'} title={'Add to project'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('projectId')} options={projects} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Add' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddToProjectPopup;